var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8HeartRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "48px",
    height: "48px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "#ff4869",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(4,4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32,53.864c-0.141,0 -0.282,-0.03 -0.413,-0.089c-13.227,-6.004 -23.587,-18.674 -23.587,-28.845c0,-7.055 5.747,-12.794 12.811,-12.794c4.383,0 8.055,2.138 11.189,6.526c3.135,-4.388 6.807,-6.526 11.189,-6.526c7.064,0 12.811,5.739 12.811,12.794c0,10.171 -10.36,22.841 -23.587,28.844c-0.131,0.06 -0.272,0.09 -0.413,0.09z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8HeartRed);
export default __webpack_public_path__ + "static/media/icons8-heart-red.7cd7cce9d63d8b478395f8d270f44c14.svg";
export { ForwardRef as ReactComponent };